import fifthaveClient from './fifthaveClient';

export function getWorldAreas(code?: string) {
    return fifthaveClient.get(`/api/v1/basic-data/world-areas${code ? `/${code}` : ''}?scenario=SHIPPING_ADDRESS`);
}

export function checkoutMock(params) {
    return fifthaveClient.post('/api/v1/simulation/submit', params, {
        headers: {
            'X-BXL-User-Agent': 'Bieyang Android/3.4.1 (ANA-AN00; HUAWEI; Android 10; UID 164f9941-68eb-46e6-a39e-048793b16e1c) NETWORK_WIFI'
        }
    });
}